import { QuillEditor } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import styled from "styled-components"
import { CaptionText } from "./Caption"

const StyledCaptionContainer = styled(Content.Container)`
  .ContentText.ql-editor {
    overflow: visible;
  }
`

const CaptionEdit = ({ onChange, caption, autoFocus, bounds }) => {
  return (
    <StyledCaptionContainer className="CaptionEdit">
      <CaptionText>
        <QuillEditor
          html={caption.html}
          onChange={(html) => onChange({ ...caption, html })}
          onTextCleared={() => onChange(null)}
          editorProps={{ blockButtons: [] }}
          autofocus={autoFocus}
          singleLine
          controlled
          bounds={bounds}
          createCustomToolbar={({ getMergedToolbarConfig }) =>
            getMergedToolbarConfig({
              excludedOptions: "list"
            })
          }
        />
      </CaptionText>
    </StyledCaptionContainer>
  )
}

export default CaptionEdit
